// Import basic js
require('./frontend');
// Import template specific js
require('./templatestyles/classic/classic');